import { SharedAssetRequestStatus } from 'types/api/sharedAssets/requests'

import type {
  IncomingRequestByAssetId,
  TeamWithSharedAssetsInformation
} from 'hooks/use-manage-shared-assets'

export const NAMESPACE_CHIP_LIST_MAX_HEIGHT = 350
export const CLUSTER_LIST_PAGE_SIZE = 5

export enum ShareableListType {
  SHARED = 'shared',
  NOT_SHARED = 'not_shared'
}

export function getPendingNamespaceRequestsFromTeam(
  activeTeam: TeamWithSharedAssetsInformation,
  pendingNamespaceRequestsToRemove: IncomingRequestByAssetId[]
) {
  const pendingNamespacesToRemove = new Set(
    pendingNamespaceRequestsToRemove.map(({ namespace }) => namespace)
  )

  return activeTeam.requests[SharedAssetRequestStatus.REQUESTED].filter(
    (pendingRequest) => !pendingNamespacesToRemove.has(pendingRequest.namespace)
  )
}

export function getApprovedNamespaceRequestsFromTeam(
  activeTeam: TeamWithSharedAssetsInformation,
  approvedNamespaceRequestsToRemove: IncomingRequestByAssetId[]
) {
  const approvedNamespacesToRemove = new Set(
    approvedNamespaceRequestsToRemove.map(({ namespace }) => namespace)
  )

  return activeTeam.requests[SharedAssetRequestStatus.APPROVED].filter(
    (approvedRequest) =>
      !approvedNamespacesToRemove.has(approvedRequest.namespace)
  )
}

export function getSubmitButtonText(
  pendingNamespaceRequests: IncomingRequestByAssetId[],
  approvedNamespaceRequestsToRemove: IncomingRequestByAssetId[],
  selectedNamespacesToAdd: string[]
): string {
  if (
    (approvedNamespaceRequestsToRemove.length > 0 ||
      selectedNamespacesToAdd.length > 0) &&
    pendingNamespaceRequests.length > 0
  ) {
    return 'Approve And Save'
  }

  if (pendingNamespaceRequests.length > 0) {
    return 'Approve'
  }

  return 'Save'
}
